import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles((theme) =>
  createStyles({
    cell: {
      overflow: 'visible',
      textAlign: 'center',
      padding: 0,
      // Отключаем userSelect, поскольку при кликах на checkbox выделялся текст колонки справа от чекбокса
      userSelect: 'none',
      // Поскольку onClick на всей ячейки, то при наведении на ячейку выделяем чекбокс.
      '&:hover:not($disabled)': {
        cursor: 'pointer',
        '& $checkbox': {
          color: '#333',
          backgroundColor: 'rgba(16, 156, 241, 0.04)',
        },
        '& $checkbox.Mui-checked': {
          color: theme.palette.primary.main,
          backgroundColor: 'rgba(16, 156, 241, 0.04)',
        },
      },
    },
    pointer: {
      cursor: 'pointer',
    },
    disabled: {
      cursor: 'default',
      '& $checkbox': {
        cursor: 'default',
      },
    },
    alignWithRowSpan: {
      verticalAlign: 'bottom',
    },
    checkbox: {
      padding: theme.spacing(1),
    },
  })
);
